import {
    Node,
    nodeInputRule,
    mergeAttributes, isString,
} from '@tiptap/core'
import {NodeView} from "@tiptap/pm/view";
import {AiGeneratorView} from "./ai-generator-view";


declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        aiGenerator: {
            setAiGenerator: (options: { prompt: string }) => ReturnType,
        }
    }
}

export const AiGeneratorNode = Node.create({
    name: "aiBlock",

    content: 'block*',

    group: 'block',

    defining: true,

    draggable: false,

    addNodeView() {
        return ({editor, node, getPos, HTMLAttributes, decorations, extension}): NodeView => {
            let attrs = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes);

            let nodeview = new AiGeneratorView(editor, attrs, getPos)

            console.log("NNNNN:", nodeview.domContent);

            return {
                dom: nodeview.dom,
                //contentDOM: nodeview.domContent,
                selectNode: () => {
                    nodeview.selectNode();
                },
                deselectNode: () => {
                    console.log("ZZZ DESELECT NODE: ", node);
                    nodeview.deselectNode();
                },
            }
        }
    },

    addAttributes() {
        return {
            prompt: {
                parseHTML: element => ({
                    'prompt': element.getAttribute('data-prompt')
                }),
                renderHTML: attributes => {
                    let promptAttr = attributes["prompt"];
                    if (!isString(promptAttr)) {
                        promptAttr = "";
                    }
                    return {
                        'data-prompt': promptAttr
                    }
                }
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-prompt]',
            },
        ]
    },

    renderHTML({HTMLAttributes}) {
        return ['div', mergeAttributes({"data-prompt": ''}, this.options.HTMLAttributes, HTMLAttributes)]
    },

    addCommands() {
        return {
            setAiGenerator:
                (options) =>
                    ({commands, chain}) => {

                    return chain()
                        // .insertContent([
                        //     {
                        //         type: 'paragraph',
                        //         content: [
                        //             {
                        //                 type: 'text',
                        //                 text: '\r\n',
                        //             },
                        //         ],
                        //     },
                        // ])
                        .insertContent({
                            type: this.name,
                            attrs: options,
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [
                                        {
                                            type: 'text',
                                            text: ' ',
                                        },
                                    ],
                                },
                            ]
                        })
                        .run();
                    },
        }
    }
})


/*


export interface AiGeneratorOptions {
    inline: boolean,
    prompt: string,
    HTMLAttributes: Record<string, any>,
}


export const inputRegex = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const AiGenerator = Node.create<AiGeneratorOptions>({
    name: 'ai-generator',

    defaultOptions: {
        inline: false,
        prompt: "",
        HTMLAttributes: {
            src: null,
            style: ''
        },
    },

    addNodeView(){
        return ({ editor, node, getPos, HTMLAttributes, decorations, extension }): NodeView => {
            let attrs = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes);

            let nodeview = new AiGeneratorView(editor, attrs, getPos)

            return {
                dom : nodeview.dom,
                contentDOM: nodeview.domContent,
                selectNode: () => {
                    //nodeview.selectNode();
                },
                deselectNode: () => {
                    //nodeview.deselectNode();
                },
            }
        }
    },

    inline() {
        return false;
    },

    group() {
        return 'block';
    },

    draggable: false,

    addAttributes() {
        return {
            prompt: {
                parseHTML: element => ({
                    prompt: element.getAttribute('prompt')
                }),
                renderHTML: attributes => {
                    let promptAttr = attributes["data-prompt"];
                    if(!isString(promptAttr)){
                        promptAttr = "";
                    }
                    return {
                        'data-prompt': promptAttr
                    }
                }
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-prompt]',
            },
        ]
    },

    renderHTML({HTMLAttributes}) {
        return ['ai-generator', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
    },

    addCommands() {
        return {
            setAiGenerator: options => ({commands}) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },
        }
    },

    addInputRules() {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: match => {
                    const [, , alt, src, title] = match
                    return {src, alt, title}
                },
            }),
        ]
    },
})

*/